/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                     /* use pure js here */
                    const productSwatch = '<div class="webyze-multi-product-colors" data-product-id="' + productData.id + '"></div>'
                    if (!productItem.querySelector('.webyze-multi-product-colors')) {
                       productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('beforeend', productSwatch);
                    }

                    let itemCustomLabels = "";
                    let itemCustomLabelsTop = "";
                    const promoSettings = boostSDConfig.custom.promoSettings;
                    if (
                      promoSettings.promo_condition1 &&
                      promoSettings.promo_text1 &&
                      productData.tags.indexOf(promoSettings.promo_condition1) > -1
                    ) {
                      itemCustomLabelsTop +=
                        '<div class="product-price-special" style="background:' +
                        promoSettings.promo_bg1 +
                        ";color:" +
                        promoSettings.promo_color1 +
                        '">' +
                        promoSettings.promo_text1 +
                        "</div>";
                    }
                    if (
                      promoSettings.promo_condition2 &&
                      promoSettings.promo_text2 &&
                      productData.tags.indexOf(promoSettings.promo_condition2) > -1
                    ) {
                      itemCustomLabelsTop +=
                        '<div class="product-price-special" style="background:' +
                        promoSettings.promo_bg2 +
                        ";color:" +
                        promoSettings.promo_color2 +
                        '">' +
                        promoSettings.promo_text2 +
                        "</div>";
                    }
                    if (
                      promoSettings.promo_condition3 &&
                      promoSettings.promo_text3 &&
                      productData.tags.indexOf(promoSettings.promo_condition3) > -1
                    ) {
                      itemCustomLabels +=
                        '<div class="product-price-special" style="background:' +
                        promoSettings.promo_bg3 +
                        ";color:" +
                        promoSettings.promo_color3 +
                        '">' +
                        promoSettings.promo_text3 +
                        "</div>";
                    }
                    if (
                      promoSettings.promo_condition4 &&
                      promoSettings.promo_text4 &&
                      productData.tags.indexOf(promoSettings.promo_condition4) > -1
                    ) {
                      itemCustomLabels +=
                        '<div class="product-price-special" style="background:' +
                        promoSettings.promo_bg4 +
                        ";color:" +
                        promoSettings.promo_color4 +
                        '">' +
                        promoSettings.promo_text4 +
                        "</div>";
                    }
                    if (
                      promoSettings.promo_condition5 &&
                      promoSettings.promo_text5 &&
                      productData.tags.indexOf(promoSettings.promo_condition5) > -1
                    ) {
                      itemCustomLabels +=
                        '<div class="product-price-special" style="background:' +
                        promoSettings.promo_bg5 +
                        ";color:" +
                        promoSettings.promo_color5 +
                        '">' +
                        promoSettings.promo_text5 +
                        "</div>";
                    }
                    if (!productItem.querySelector('.product-price-special')) {
                       productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('beforeend', itemCustomLabels);
                       itemCustomLabelsTop = '<div class="product-badges-wrapper">' + itemCustomLabelsTop + '</div>';
                       productItem.querySelector('.boost-sd__product-image-wrapper').insertAdjacentHTML('beforeend', itemCustomLabelsTop);
                    }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);

